// @flow

import _ from "lodash";
import URL from "domurl";

const excludeTerms: string = (function() {
  {
    // Taken from https://support.google.com/webmasters/answer/35287?hl=en. This might be overkill.
    const excludeFiletypes = [
      "pdf",
      "swf",
      "ps",
      "dwf",
      "kml",
      "kwz",
      "gpx",
      "hwp",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "odp",
      "ods",
      "odt",
      "rtf",
      "svg",
      "tex",
      "wml",
      "wap"
    ];

    return (
      "politifact factcheck " +
      excludeFiletypes.map(xt => `filetype:${xt}`).join(" ")
    );
  }
})();

export const CSE_URL: string = (function() {
  const url = new URL("https://www.googleapis.com/customsearch/v1");
  const cseAPIKey = "AIzaSyBBEaERxxop7fXIKfY7Rx1hDrn9wc0sdLU";
  const cseIdentifier = "014887276394778548623:xgw4g54b9qs";

  _.assign(url.query, {
    key: cseAPIKey,
    cx: cseIdentifier,
    excludeTerms
  });

  return url.toString();
})();

export const MERCURY_API_KEY: string =
  "DGJNV4CYUokGAQiCZ8Qh5VrlE4lrBBGjPzP49Gso";

// Most of these are defaults from `sanitize-html-react`, but copied over to be explicit.
export const ALLOWED_TAGS: Array<string> = [
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "p",
  "ul",
  "ol",
  "nl",
  "li",
  "b",
  "i",
  "strong",
  "em",
  "strike",
  "code",
  "hr",
  "br",
  "div",
  "table",
  "thead",
  "caption",
  "tbody",
  "tr",
  "th",
  "td",
  "pre",
  "img"
];



// WEBPACK FOOTER //
// ./src/components/Google/constants.js